import React, { useState } from 'react';
import {
  GeckoTable,
  GeckoModalService,
  GeckoModal,
  GeckoCard,
  GeckoCardHeader,
  GeckoCardBody,
  GeckoBtn,
  GeckoPagination,
  GeckoCardFooter,
  GECKO_CONSTS,
} from 'ui';
import GeckoLocation from 'services/gecko-location';
import { useGetRequest } from 'services/gecko-request';
import Loader from 'components/Loader';

import './index.scss';

export const FailedSyncRecordTable = ({
  integrationType,
  syncRecords,
  onClick,
}) => {
  const integrationName =
    integrationType[0].toUpperCase() +
    integrationType.substring(1, integrationType.length);
  const cols = [
    {
      key: 'id',
      name: 'ID',
      width: '5%',
    },
    {
      key: 'third_party_id',
      name: `${integrationName} ID`,
      width: '10%',
    },
    {
      key: 'metadata.error',
      name: 'Error',
      width: '35%',
    },
    {
      key: 'metadata.entity',
      name: `${integrationName} Values`,
      width: '45%',
      render: (vals) => {
        return JSON.stringify(vals);
      },
    },
    {
      key: '__actions',
      name: 'Actions',
      align: 'center',
      width: '5%',
      render: (_, row) => {
        const config = {
          icon: 'far fa-eye',
          type: GECKO_CONSTS.BTN_TYPE_NAKED,
          tooltip: 'View Failed Import',
          handler: () => onClick(row),
        };
        return <GeckoBtn {...config} />;
      },
    },
  ];
  return (
    <div className="ImportFailures-failure-table">
      <GeckoTable cols={cols} rows={syncRecords} />
    </div>
  );
};

export const FailedSyncRecordModal = ({ integrationType, syncRecord }) => {
  const integrationName =
    integrationType[0].toUpperCase() +
    integrationType.substring(1, integrationType.length);
  const SummaryGroup = ({ label, type, children }) => {
    return (
      <div
        className={`ImportFailures-summary-modal-group ImportFailures-summary-modal-group-${type}`}
      >
        <label className="ImportFailures-summary-modal-label">{label}</label>
        <div className={`ImportFailures-summary-modal-value`}>{children}</div>
      </div>
    );
  };
  return (
    <div className="ImportFailures-summary-modal">
      <GeckoModal name="Error Summary">
        <SummaryGroup label="ID" type="id">
          {syncRecord.id}
        </SummaryGroup>
        <SummaryGroup label={`${integrationName} ID`} type="third_party_id">
          {syncRecord.third_party_id}
        </SummaryGroup>
        <SummaryGroup label="Error" type="error">
          {syncRecord.metadata.error}
        </SummaryGroup>
        <SummaryGroup label={`${integrationName} Values`} type="values">
          <code>
            <pre>{JSON.stringify(syncRecord.metadata.entity, null, 4)}</pre>
          </code>
        </SummaryGroup>
      </GeckoModal>
    </div>
  );
};

export default ({ parentSyncId }) => {
  const [page, setPage] = useState(1);
  const [fetchedParentSyncRecord, isLoadingParent] = useGetRequest(
    `/sync_records/${parentSyncId}`
  );
  const [
    fetchedSyncRecords,
    isLoadingRecords,
  ] = useGetRequest(`/sync_records/failed`, { parent_id: parentSyncId, page });

  const isLoading = isLoadingParent || isLoadingRecords;
  const parentSyncRecord = fetchedParentSyncRecord || null;
  const syncRecords = fetchedSyncRecords || [];

  const onSyncRecordClick = (syncRecord) => {
    new GeckoModalService().open(() => (
      <FailedSyncRecordModal
        integrationType={parentSyncRecord.integration_type}
        syncRecord={syncRecord}
      />
    ));
  };

  const totalItems = parentSyncRecord ? parentSyncRecord.metadata.failed : 0;
  const pagination = {
    total_items: totalItems,
    current_page: page,
    total_pages: Math.ceil(totalItems / 50),
    changePage: setPage,
  };

  return (
    <div className="content-margin">
      <Loader isLoading={isLoading}>
        <div className="ImportFailures">
          <GeckoCard>
            <GeckoCardHeader
              name="Failed Imports"
              onBack={() =>
                GeckoLocation.goTo(
                  `/settings/integration/${parentSyncRecord.integration_type}`
                )
              }
            />
            <GeckoCardBody>
              <FailedSyncRecordTable
                integrationType={
                  parentSyncRecord
                    ? parentSyncRecord.integration_type
                    : 'Integration'
                }
                syncRecords={syncRecords}
                onClick={onSyncRecordClick}
              />
            </GeckoCardBody>
            <GeckoCardFooter>
              <GeckoPagination pagination={pagination} />
            </GeckoCardFooter>
          </GeckoCard>
        </div>
      </Loader>
    </div>
  );
};
